module.exports = __webpack_public_path__ + "static/new_meeting_room-f52535a2e66c5249daf0694bbcb28f29.jpg";